import { render, staticRenderFns } from "./languagePicker.vue?vue&type=template&id=312a6356&lang=pug&"
import script from "./languagePicker.vue?vue&type=script&lang=js&"
export * from "./languagePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports